import { ISettings } from 'web-core-src';

export interface ISettingsStorage {
    initSettingsStorage(appSettings: ISettings, coreSettings: ISettings): void;
    initSettings(appSettings: ISettings, coreSettings: ISettings): Promise<void>;
    resetAllModuleSettingsWithDefaultValues(): Promise<void>;
    loadSettingsFromStorage(): Promise<void>;
}
